<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="4">
          <DateIOSPicker label="Ngày" :date.sync="time" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="status"
            :items="attendanceStatus"
            item-text="title"
            item-value="status"
            label="Trạng thái"
            dense
            outlined
            hide-details
            clearable
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <CheckboxAcademicLevel :isDefaultCheckAll="false" @change="academicLevelChanged"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete
            no-data-text="Danh sách rỗng"
            :items="typeList"
            item-text="title"
            item-value="value"
            v-model="type"
            label="Loại cán bộ"
            outlined
            clearable
            hide-details="auto"
            dense
            @change="teacherTypeChanged"
          >
          </v-autocomplete>
        </v-col>
        <v-col>
          <AutocompleteSubjectGroup
            clear-icon="mdi-close"
            v-model="subjectGroup"
            label="Lĩnh vực"
            item-text="title"
            outlined
            dense
            return-object
            hide-details="auto"
            @change="subjectGroupChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <AutocompleteTeacherCard
            :syncedValue.sync="teacher"
            item-text="name"
            clear-icon="mdi-close"
            label="Giáo viên"
            outlined
            dense
            hide-details="auto"
            deletable-chips
            :filter="teacherFilter"
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import CheckboxAcademicLevel from '../../../modules/academicLevel/CheckboxAcademicLevel.vue'
import AutocompleteTeacherCard from '../../../components/basic/input/AutocompleteTeacherCard.vue'
import AutocompleteSubjectGroup from '../../../components/basic/input/AutocompleteSubjectGroup.vue'
import { get } from 'lodash'
import { mapState } from 'vuex'

export default {
  components: {
    DateIOSPicker,
    CheckboxAcademicLevel,
    AutocompleteTeacherCard,
    AutocompleteSubjectGroup,
  },
  data() {
    return {
      time: moment().toISOString(),
      type: '',
      subjectGroup: null,
      academicLevels: [],
      teacher: null,
      status: '',
      typeList: [
        { title: 'Thỉnh giảng', value: 'short-term' },
        { title: 'Biên chế', value: 'long-term' },
        { title: 'Hợp đồng', value: 'short-term-contract' },
      ],
    }
  },
  computed: {
    ...mapState('constant', ['attendanceStatus']),
    teacherFilter() {
      const filters = {
        subjectGroup: get(this.subjectGroup, 'id'),
        type: this.type,
        status: 'active',
      }
      if (Array.isArray(this.academicLevels) && this.academicLevels.length) {
        filters.academicLevels_in = this.academicLevels.map(a => a.id)
      }
      return filters
    },
  },
  methods: {
    academicLevelChanged(academicLevels) {
      this.academicLevels = academicLevels
      this.teacher = null
    },
    subjectGroupChanged(subjectGroup) {
      this.subjectGroup = subjectGroup
      this.teacher = null
    },
    teacherTypeChanged(type) {
      this.type = type
      this.teacher = null
    },
    onFilterChanged() {
      const params = {
        date: this.time,
        academicLevels_in: this.academicLevels.map(a => a.id),
        subjectGroup: get(this.subjectGroup, 'id'),
        teacher: get(this.teacher, 'id'),
        status: this.status,
        teacherType: this.type,
      }
      this.$emit('onFilterChanged', params)
    },
  },
}
</script>

<style scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;
  padding: 0;
}
.filter-options {
  width: calc(100% - 120px);
  display: inline-block;
}
.filter-submit {
  width: 120px;
  display: inline-block !important;
  align-self: flex-end;
}
.search-button {
  width: 100%;
}

@media screen and (max-width: 960px) {
  .filter-wrapper {
    display: block;
    width: 100%;
  }
  .filter-options {
    width: 100%;
  }
  .filter-submit {
    width: 100%;
    margin-top: 24px;
  }
  .search-button {
    width: 120px;
    align-items: right;
    float: right;
  }
}

</style>
